import React from "react";
import Img from "gatsby-image";
import { graphql, useStaticQuery } from "gatsby";
import get from "lodash/get";

const DefaultThumb = ({ big }) => {
  const { file } = useStaticQuery(query);
  const fixed = big
    ? get(file, "childImageSharp.bigThumb")
    : get(file, "childImageSharp.lilThumb");
  return fixed ? (
    <Img fixed={fixed} alt="North Texas Municipal Water District Logo" />
  ) : null;
};

export default DefaultThumb;

const query = graphql`
  {
    file(name: { eq: "ntmwd_default" }) {
      childImageSharp {
        bigThumb: fixed(width: 340, height: 220) {
          ...GatsbyImageSharpFixed_withWebp
        }
        lilThumb: fixed(width: 100, height: 80) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`;
